export const CRM_SIGN_IN_TYPE = {
    NONE: 'none',
    PROFILE_PROVIDER: 'profileProvider',
    SAML_SSO: 'samlSSO'
};



// WEBPACK FOOTER //
// ./src/constants/crm-sign-in-type.js